import { ReactNode } from 'react';
import { Footer } from 'src/components/footer/footer';
import { Header } from 'src/components/header/header';

export const HouseLayout = (page: ReactNode): ReactNode => {
  return (
    <div className="flex min-h-full flex-col">
      <div className="h-header" />
      <div className="z-fullscreen fixed top-0 w-full bg-white lg:border-b-0">
        <Header />
      </div>
      <main className="flex-1">{page}</main>
      <Footer />
    </div>
  );
};
